 import Cookies from "js-cookie";

 
 const cachekey_cookies="CallMe_PC"; //前端缓存键
 const cachekey_default="ASP.NET_SessionId";//系统默认缓存的


 const getGuid=()=> {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0,
          v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
  });
}

export function getSessionId(){
  if(typeof Cookies.get(cachekey_default)=="undefined"){ 
    //系统默认的cookie不存在时，则自动生成
    if(typeof Cookies.get(cachekey_cookies)=="undefined"){
      let guid=getGuid();
      Cookies.set(cachekey_cookies,guid); 
      return guid;
   }else{
     return Cookies.get(cachekey_cookies);
   }
  }else{
    return Cookies.get(cachekey_default);
  }
};

